import { toast } from 'react-toastify';
import { Read } from 'services/cobranca';
import { StatusContent } from 'ui/styled';
import { normalizeResponse, selectColors } from 'utils';
import { CANCELLED_STATUS } from 'utils/billing';
import { parseCurrency } from 'utils/parsers';
import { formatadores, normalizeName } from 'utils/validators';

// O botao Renegociar da coluna AÇÃO, compartilhado pelas telas do menu
// Cobranca que oferecem renegociacao (Renegociacao e Notificacao).
//
// A coluna AÇÃO continua sendo de cada tela: cada uma compoe a celula no seu
// `overrides`. So este botao mora aqui porque ele carrega o mapeamento
// temporario abaixo, que nao pode ser copiado de tela em tela.

// Taxa padrao da renegociacao, usada quando ainda nao ha `renegociacao_taxa`
// salva (o modal da preferencia a ela): os juros do proprio contrato, depois a
// taxa das regras de cobranca da distribuidora, depois a primeira taxa de
// financiamento dela. Sem nenhuma, vai vazia para o operador preencher; antes
// ia "null%", e o campo numerico do modal aparecia vazio sem explicacao.
const defaultRate = (a) => {
  const rate = [
    a?.perc_juros,
    a?.distribuidor?.cobranca_regras_gerais?.perc_taxa,
    a?.distribuidor?.taxas?.[0]?.perc_taxa,
  ].find((value) => value !== null && value !== undefined && value !== '');
  return rate === undefined ? '' : `${rate}%`;
};

// TEMPORARIO: mesmo mapeamento da antiga tela Banking/Renegociacao (removida
// no e9e034e). O modal BankingRenegociacao le os campos ja achatados.
const toRenegociacaoRow = (a) => ({
  id: a?.id,
  date: a?.createdAt,
  formatedDate: formatadores.TIMESTAMP_TO_BR(a?.createdAt),
  cliente: a?.cliente,
  clienteid: a?.cliente?.id,
  distributor: normalizeName(a?.distribuidor?.trade_name) || '',
  distribuidorid: a?.distribuidor?.id,
  bankingid: !a?.banking ? '' : a?.banking.id,
  propostaid: !a?.proposta_financeira ? '' : a?.proposta_financeira.id,
  taxas: a?.distribuidor?.taxas,
  taxasbanco: a?.banco?.regras_cobranca,
  integrator:
    normalizeName(a?.proposta_financeira?.integrador?.nome_fantasia) || '',
  customer: normalizeName(a?.cliente?.nome_completo) || '',
  value: parseCurrency(a?.valor_financiado),
  bureau_perfil: a?.banking?.bureau_perfil || '-',
  taxa: defaultRate(a),
  seguro: a?.seguro,
  pmt: parseCurrency(a?.valor_pmt),
  saldo: parseCurrency(a?.valor_saldo),
  banco: normalizeName(a?.banco?.nome_fantasia),
  bancoid: a?.banco?.id,
  telefone: a?.cliente?.telefone_celular,
  status: a?.status,
  titulos: a?.titulos,
  perc_tac: a?.perc_tac,
  perc_iof: a?.perc_iof,
  valor_seguro_assistencia: a?.banco?.regras_cobranca?.valor_seguro_assistencia,
  renegociacao_taxa: a?.renegociacao_taxa,
  renegociacao_periodicidade: a?.renegociacao_periodicidade,
  renegociacao_prazo: a?.renegociacao_prazo,
  renegociacao_seguro: a?.renegociacao_seguro,
  renegociacao_seguro_assistencia: a?.renegociacao_seguro_assistencia,
  renegociacao_saldodevedor: a?.renegociacao_saldodevedor,
  renegociacao_iof: a?.renegociacao_iof,
  renegociacao_data_1parcela: a?.renegociacao_data_1parcela,
  renegociacao_entrada: a?.renegociacao_entrada,
  parcelas_origem: a?.parcelas_origem,
  carteira: a?.carteira,
  contato_cliente: a?.contato_cliente,
  confirma_cliente: a?.confirma_cliente,
  taxasiof: a?.distribuidor?.cobranca_regras_gerais,
  renegociacao_tab: a?.renegociacao_tab,
  renegociacao_tac: a?.renegociacao_tac,
});

// Cobranca cancelada nao pode ser renegociada (o backend devolve 400): quem
// renegocia e a original.
export const RenegotiateButton = ({ row, setModal, reload }) =>
  row?.status === CANCELLED_STATUS ? null : (
    <StatusContent
      color={selectColors(row?.status)}
      style={{ cursor: 'pointer' }}
      onClick={async () => {
        // TEMPORARIO: abre o modal antigo de renegociacao
        // (BankingRenegociacao) para relembrar o fluxo. Ele espera o registro
        // cru da cobranca, igual a antiga tela Banking/Renegociacao, e nao a
        // linha montada pelo utils/billing — por isso busca pelo id.
        // Original: setModal({ type: 'cobranca', dados: row, reload });
        const result = await Read(`?filters[id]=${row?.id}`);
        const [raw] = normalizeResponse(result) || [];
        if (!raw) {
          toast.error('Cobrança não encontrada.');
          return;
        }
        const dados = toRenegociacaoRow(raw);
        if (!dados.taxasiof || !dados.taxasbanco) {
          toast.info(
            'Não localizado o cadastro das regras, verifique com o administrador'
          );
          return;
        }
        setModal({ type: 'renegociar', dados, reload });
      }}
    >
      Renegociar
    </StatusContent>
  );
